import LeistungsseiteTemplate from "@/components/feature/LeistungsseiteTemplate";
import { allTestimonials } from "@/data/testimonials";
import asset_notstrom_hero_bg from "@/assets/notstrom-hero-bg.png";
import asset_notstrom_was_brauchen_sie from "@/assets/notstrom-was-brauchen-sie.png";
import asset_notstrom_speicher_als_backup from "@/assets/notstrom-speicher-als-backup.png";
import asset_notstrom_referenz_einfamilienhaus from "@/assets/notstrom-referenz-einfamilienhaus.png";
import asset_notstrom_stromspeicher from "@/assets/notstrom-stromspeicher.png";
import Seo, { serviceSchema } from "@/components/feature/Seo";

export default function Notstrom() {
  return (
    <>
      <Seo
        title="Notstrom & Ersatzstrom | Zweering Elektrotechnik Emmerich am Rhein"
        description="Notstrom- und Ersatzstromlösungen vom Elektro-Meisterbetrieb — bedarfsgerecht geplant und installiert in Emmerich am Rhein und Umgebung."
        canonical="https://zweering.de/notstrom"
        breadcrumbs={[{"name": "Startseite", "url": "https://zweering.de/"}, {"name": "Leistungen", "url": "https://zweering.de/notstrom"}, {"name": "Notstrom & Ersatzstrom", "url": "https://zweering.de/notstrom"}]}
        schema={serviceSchema("Notstrom- und Ersatzstromlösungen", "Bedarfsgerechte Planung und Installation von Notstrom- und Ersatzstromlösungen für Wohn- und Gewerbeobjekte in Emmerich am Rhein und Umgebung.", "https://zweering.de/notstrom")}
      />
      <LeistungsseiteTemplate
      label="LEISTUNGEN"
      title="NOTSTROM & ERSATZSTROM"
      subline="Sicherheit, wenn das Netz ausfällt. Notstrom- und Ersatzstromlösungen vom Elektro-Meisterbetrieb in Emmerich am Rhein und Umgebung."
      heroImage={asset_notstrom_hero_bg}
      heroImageAlt="Einfamilienhaus bei Nacht mit warm beleuchteten Fenstern und Außenbeleuchtung"
      leadText={
        <>
          Stromausfälle sind selten — aber wenn sie kommen, wird schnell klar, wie viel
          vom Strom abhängt. Eine durchdachte Notstromlösung sorgt dafür, dass{" "}
          <span style={{ color: "#4CAF50" }}>Ihr Zuhause weiterläuft</span>, auch wenn das
          Netz Pause macht.
        </>
      }
      panels={[
        {
          title: "WAS BRAUCHEN SIE WIRKLICH?",
          body: "Notstrom kann vieles bedeuten — vom kurzen Überbrücken bis zum mehrtägigen Inselbetrieb. Wir prüfen, was in Ihrem Fall sinnvoll und wirtschaftlich ist.",
          image: asset_notstrom_was_brauchen_sie,
          imageAlt: "Wechselrichter und Sicherungskasten sauber an der Wand montiert",
        },
        {
          title: (
            <>
              <span style={{ color: "#4CAF50" }}>SPEICHER</span> ALS BACKUP
            </>
          ),
          body: "Mit der passenden Technik kann Ihr PV-Speicher bei Netzausfall einspringen — Ersatzstrom für die wichtigsten Verbraucher, ohne zusätzliches Aggregat.",
          image: asset_notstrom_speicher_als_backup,
          imageAlt: "Wechselrichter und Batteriespeicher sauber an der Wand montiert",
        },
        {
          title: "SAUBERE INSTALLATION",
          body: "Umschaltung, Absicherung und Anbindung an Ihre Elektroinstallation durch unseren Meisterbetrieb — fachgerecht und nach allen Normen.",
          image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2024/11/IMG_0143.jpeg",
          imageAlt: "Saubere Notstrom-Installation durch Zweering Elektrotechnik",
        },
        {
          title: "EIN ANSPRECHPARTNER",
          body: "Planung, Installation und Service aus einer Hand — auch dann, wenn es ernst wird.",
          image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2024/01/IMG_0206.jpeg",
          imageAlt: "Service-Team von Zweering Elektrotechnik",
          titleSize: "clamp(1.125rem, 3.2vw, 2.25rem)",
          titleClassName: "break-keep",
        },
      ]}
      testimonials={allTestimonials}
      trustLine="Vertrauen unserer Kundinnen und Kunden am Niederrhein."
      manifest={"WENN DAS NETZ PAUSE MACHT.\nLÄUFT IHR ZUHAUSE WEITER."}
      caseStudy={{
        title: "ERSATZSTROM FÜR EIN EINFAMILIENHAUS",
        text: "PV-Speicher mit Ersatzstromfunktion eingebunden — die wichtigsten Verbraucher laufen auch bei Netzausfall weiter.",
        href: "#referenzen",
        image: asset_notstrom_referenz_einfamilienhaus,
        imageAlt: "Einfamilienhaus bei Nacht mit warm beleuchteten Fenstern und Außenbeleuchtung",
      }}
      faq={[
        {
          frage: "Was ist der Unterschied zwischen Notstrom und Ersatzstrom?",
          antwort:
            "Notstrom überbrückt kurze Ausfälle für einzelne Geräte. Ersatzstrom versorgt einen Teil des Hauses länger — z. B. über Ihren PV-Speicher.",
        },
        {
          frage: "Kann mein PV-Speicher das übernehmen?",
          antwort:
            "Viele moderne Speicher bieten eine Ersatzstromfunktion. Ob Ihr System dazu in der Lage ist, prüfen wir gemeinsam.",
        },
        {
          frage: "Brauche ich dafür ein zusätzliches Aggregat?",
          antwort:
            "Nicht zwingend. Oft reicht eine passend ausgelegte Speicherlösung — wir beraten Sie ehrlich, was bei Ihnen sinnvoll ist.",
        },
      ]}
      ctaText={{
        headline: "BEREIT FÜR DEN ERNSTFALL?",
        subtext: "Kostenlose Beratung — wir planen Ihre Ersatzstromlösung.",
        buttonLabel: "Erstberatung anfragen",
        buttonHref: "/kontakt",
        variant: "green",
      }}
      crossLink={{
        title: "STROMSPEICHER",
        text: "Speicher mit Ersatzstromfunktion — die elegante Notstromlösung.",
        href: "/stromspeicher",
        image: asset_notstrom_stromspeicher,
        imageAlt: "Stromspeicher mit Ersatzstromfunktion",
      }}
    />
    </>
  );
}
